interface Reviewer {
  locale: string;
  data: Array<{
    name: string;
    job: string;
    content: string;
  }>;
}

export default class ReviewLocale {
  public data: Array<{
    name: string;
    job: string;
    content: string;
    icon?: string;
  }> = [];

  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
    this.data.forEach((item, index) => {
      item.icon = "/customer/" + item.name + ".png";
    });
  }
}

const dataLocales: Array<Reviewer> = [
  {
    locale: "en",
    data: [
      {
        name: "Alaya Walsh",
        job: "Writer",
        content:
          "Using QR codes for wedding invitations was a breeze with QR Dove, the leading QR Code platform. Sharing event details with friends and family became seamless, thanks to its compatibility across all devices.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & founder",
        content:
          "QR Dove's customer support is exceptional! This QR Code platform provides friendly, knowledgeable service that ensures all issues are resolved promptly. I highly recommend QR Dove and look forward to using it for years to come.",
      },
      {
        name: "Vincent Vu",
        job: "Developer",
        content:
          "As a web developer, I've tested numerous tools, but QR Dove stands out as the best QR Code platform. Its advanced capabilities and user-friendly interface make it unrivaled in the industry.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "QR Dove is a highly efficient QR Code platform that is incredibly easy to use. The website offers detailed guides and instant answers to questions, making it the go-to choice for QR code creation. The glowing reviews were spot-on!",
      },
      {
        name: "Esmee Allen",
        job: "Sales Manager",
        content:
          "Our team has been using QR Dove for over six months and loves it! This QR Code platform simplifies the creation, design, and deployment of QR codes, and their outstanding customer support ensures a smooth experience.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketer",
        content:
          "QR Dove is the ultimate QR Code platform! I've been using it for four months and can't recommend it enough. It's reliable, efficient, and perfect for all marketing needs.",
      },
    ],
  },

  {
    locale: "fr",
    data: [
      {
        name: "Alaya Walsh",
        job: "Écrivain",
        content:
          "L'utilisation de codes QR pour les invitations de mariage a été un jeu d'enfant avec QR Dove, la principale plateforme de codes QR. Partager les détails de l'événement avec les amis et la famille est devenu facile, grâce à sa compatibilité sur tous les appareils.",
      },
      {
        name: "Lawrence Holland",
        job: "PDG et fondateur",
        content:
          "Le service client de QR Dove est exceptionnel ! Cette plateforme de codes QR offre un service amical et compétent qui garantit que tous les problèmes sont résolus rapidement. Je recommande vivement QR Dove et j'ai hâte de l'utiliser pendant de nombreuses années.",
      },
      {
        name: "Vincent Vu",
        job: "Développeur",
        content:
          "En tant que développeur web, j'ai testé de nombreux outils, mais QR Dove se distingue comme la meilleure plateforme de codes QR. Ses capacités avancées et son interface conviviale la rendent inégalée dans l'industrie.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "QR Dove est une plateforme de codes QR très efficace et incroyablement facile à utiliser. Le site web propose des guides détaillés et des réponses instantanées aux questions, ce qui en fait le choix idéal pour la création de codes QR. Les critiques élogieuses étaient justifiées !",
      },
      {
        name: "Esmee Allen",
        job: "Directrice des ventes",
        content:
          "Notre équipe utilise QR Dove depuis plus de six mois et l'adore ! Cette plateforme de codes QR simplifie la création, la conception et le déploiement des codes QR, et leur excellent service client assure une expérience fluide.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketeur",
        content:
          "QR Dove est la plateforme de codes QR ultime ! Je l'utilise depuis quatre mois et je ne saurais trop la recommander. Elle est fiable, efficace et parfaite pour tous les besoins marketing.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        name: "Alaya Walsh",
        job: "Scrittore",
        content:
          "Utilizzare i codici QR per gli inviti di matrimonio è stato un gioco da ragazzi con QR Dove, la piattaforma di codici QR leader. Condividere i dettagli dell'evento con amici e familiari è diventato semplice, grazie alla sua compatibilità con tutti i dispositivi.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO e fondatore",
        content:
          "L'assistenza clienti di QR Dove è eccezionale! Questa piattaforma di codici QR offre un servizio cordiale e competente che garantisce la risoluzione rapida di tutti i problemi. Consiglio vivamente QR Dove e non vedo l'ora di usarlo per gli anni a venire.",
      },
      {
        name: "Vincent Vu",
        job: "Sviluppatore",
        content:
          "Come sviluppatore web, ho testato numerosi strumenti, ma QR Dove si distingue come la migliore piattaforma di codici QR. Le sue capacità avanzate e l'interfaccia user-friendly la rendono ineguagliabile nel settore.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "QR Dove è una piattaforma di codici QR altamente efficiente che è incredibilmente facile da usare. Il sito web offre guide dettagliate e risposte istantanee alle domande, rendendolo la scelta ideale per la creazione di codici QR. Le recensioni positive erano azzeccate!",
      },
      {
        name: "Esmee Allen",
        job: "Responsabile vendite",
        content:
          "Il nostro team utilizza QR Dove da oltre sei mesi e lo adora! Questa piattaforma di codici QR semplifica la creazione, la progettazione e l'implementazione dei codici QR e il loro eccezionale supporto clienti garantisce un'esperienza fluida.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketer",
        content:
          "QR Dove è la piattaforma di codici QR definitiva! La uso da quattro mesi e non posso raccomandarla abbastanza. È affidabile, efficiente e perfetta per tutte le esigenze di marketing.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        name: "Alaya Walsh",
        job: "Autorin",
        content:
          "Die Verwendung von QR-Codes für Hochzeitseinladungen war mit QR Dove, der führenden QR-Code-Plattform, ein Kinderspiel. Das Teilen von Veranstaltungsdetails mit Freunden und Familie wurde dank der Kompatibilität mit allen Geräten nahtlos.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & Gründer",
        content:
          "Der Kundensupport von QR Dove ist außergewöhnlich! Diese QR-Code-Plattform bietet einen freundlichen, sachkundigen Service, der sicherstellt, dass alle Probleme umgehend gelöst werden. Ich empfehle QR Dove wärmstens und freue mich darauf, es noch viele Jahre zu nutzen.",
      },
      {
        name: "Vincent Vu",
        job: "Entwickler",
        content:
          "Als Webentwickler habe ich zahlreiche Tools getestet, aber QR Dove sticht als die beste QR-Code-Plattform hervor. Seine fortschrittlichen Funktionen und die benutzerfreundliche Oberfläche machen es in der Branche unübertroffen.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designerin",
        content:
          "QR Dove ist eine hocheffiziente QR-Code-Plattform, die unglaublich einfach zu bedienen ist. Die Website bietet detaillierte Anleitungen und sofortige Antworten auf Fragen, was sie zur ersten Wahl für die Erstellung von QR-Codes macht. Die positiven Bewertungen waren zutreffend!",
      },
      {
        name: "Esmee Allen",
        job: "Verkaufsleiterin",
        content:
          "Unser Team verwendet QR Dove seit über sechs Monaten und ist begeistert! Diese QR-Code-Plattform vereinfacht die Erstellung, das Design und die Bereitstellung von QR-Codes, und der hervorragende Kundensupport sorgt für eine reibungslose Erfahrung.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketingexperte",
        content:
          "QR Dove ist die ultimative QR-Code-Plattform! Ich benutze sie seit vier Monaten und kann sie nicht genug empfehlen. Sie ist zuverlässig, effizient und perfekt für alle Marketingbedürfnisse.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        name: "Alaya Walsh",
        job: "Escritora",
        content:
          "Usar códigos QR para las invitaciones de boda fue muy fácil con QR Dove, la plataforma líder de códigos QR. Compartir los detalles del evento con amigos y familiares se volvió sencillo, gracias a su compatibilidad con todos los dispositivos.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO y fundador",
        content:
          "¡El servicio de atención al cliente de QR Dove es excepcional! Esta plataforma de códigos QR ofrece un servicio amigable y experto que garantiza que todos los problemas se resuelvan rápidamente. Recomiendo encarecidamente QR Dove y espero usarlo durante muchos años más.",
      },
      {
        name: "Vincent Vu",
        job: "Desarrollador",
        content:
          "Como desarrollador web, he probado numerosas herramientas, pero QR Dove destaca como la mejor plataforma de códigos QR. Sus capacidades avanzadas y su interfaz fácil de usar la hacen inigualable en la industria.",
      },
      {
        name: "Libby Mcdonald",
        job: "Diseñadora",
        content:
          "QR Dove es una plataforma de códigos QR altamente eficiente e increíblemente fácil de usar. El sitio web ofrece guías detalladas y respuestas instantáneas a las preguntas, lo que la convierte en la opción ideal para la creación de códigos QR. ¡Las críticas positivas fueron acertadas!",
      },
      {
        name: "Esmee Allen",
        job: "Gerente de ventas",
        content:
          "Nuestro equipo ha estado usando QR Dove durante más de seis meses y ¡les encanta! Esta plataforma de códigos QR simplifica la creación, el diseño y la implementación de códigos QR, y su excelente atención al cliente garantiza una experiencia fluida.",
      },
      {
        name: "Kacper Bennett",
        job: "Especialista en marketing",
        content:
          "¡QR Dove es la mejor plataforma de códigos QR! La he estado usando durante cuatro meses y no puedo recomendarla lo suficiente. Es fiable, eficiente y perfecta para todas las necesidades de marketing.",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        name: "Alaya Walsh",
        job: "Schrijver",
        content:
          "Het gebruik van QR-codes voor huwelijksuitnodigingen was een fluitje van een cent met QR Dove, het toonaangevende QR-codeplatform. Het delen van evenementdetails met vrienden en familie werd naadloos, dankzij de compatibiliteit op alle apparaten.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO en oprichter",
        content:
          "De klantenservice van QR Dove is uitzonderlijk! Dit QR-codeplatform biedt vriendelijke, deskundige service die ervoor zorgt dat alle problemen snel worden opgelost. Ik raad QR Dove ten zeerste aan en kijk ernaar uit om het nog jaren te gebruiken.",
      },
      {
        name: "Vincent Vu",
        job: "Ontwikkelaar",
        content:
          "Als webontwikkelaar heb ik talloze tools getest, maar QR Dove onderscheidt zich als het beste QR-codeplatform. De geavanceerde mogelijkheden en gebruiksvriendelijke interface maken het ongeëvenaard in de branche.",
      },
      {
        name: "Libby Mcdonald",
        job: "Ontwerper",
        content:
          "QR Dove is een zeer efficiënt QR-codeplatform dat ongelooflijk gemakkelijk te gebruiken is. De website biedt gedetailleerde handleidingen en directe antwoorden op vragen, waardoor het de beste keuze is voor het maken van QR-codes. De lovende recensies waren terecht!",
      },
      {
        name: "Esmee Allen",
        job: "Verkoopmanager",
        content:
          "Ons team gebruikt QR Dove al meer dan zes maanden en is er dol op! Dit QR-codeplatform vereenvoudigt het maken, ontwerpen en implementeren van QR-codes, en de uitstekende klantenservice zorgt voor een soepele ervaring.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketeer",
        content:
          "QR Dove is het ultieme QR-codeplatform! Ik gebruik het al vier maanden en kan het niet genoeg aanbevelen. Het is betrouwbaar, efficiënt en perfect voor alle marketingbehoeften.",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        name: "Alaya Walsh",
        job: "Escritora",
        content:
          "Usar códigos QR para convites de casamento foi muito fácil com o QR Dove, a principal plataforma de códigos QR. Compartilhar os detalhes do evento com amigos e familiares tornou-se perfeito, graças à sua compatibilidade em todos os dispositivos.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO e fundador",
        content:
          "O suporte ao cliente do QR Dove é excepcional! Esta plataforma de códigos QR oferece um serviço amigável e experiente que garante que todos os problemas sejam resolvidos rapidamente. Recomendo vivamente o QR Dove e estou ansioso para o usar durante muitos anos.",
      },
      {
        name: "Vincent Vu",
        job: "Programador",
        content:
          "Como programador web, testei inúmeras ferramentas, mas o QR Dove destaca-se como a melhor plataforma de códigos QR. As suas capacidades avançadas e a interface de fácil utilização tornam-no inigualável na indústria.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "O QR Dove é uma plataforma de códigos QR altamente eficiente e incrivelmente fácil de usar. O site oferece guias detalhados e respostas instantâneas a perguntas, tornando-o a escolha ideal para a criação de códigos QR. As críticas positivas foram acertadas!",
      },
      {
        name: "Esmee Allen",
        job: "Gerente de vendas",
        content:
          "A nossa equipa tem usado o QR Dove há mais de seis meses e adora! Esta plataforma de códigos QR simplifica a criação, o design e a implementação de códigos QR, e o seu excelente apoio ao cliente garante uma experiência tranquila.",
      },
      {
        name: "Kacper Bennett",
        job: "Especialista em marketing",
        content:
          "O QR Dove é a melhor plataforma de códigos QR! Tenho usado há quatro meses e não consigo recomendar o suficiente. É fiável, eficiente e perfeito para todas as necessidades de marketing.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        name: "Alaya Walsh",
        job: "ライター",
        content:
          "一流のQRコードプラットフォームであるQR Doveを使えば、結婚式の招待状にQRコードを使用するのが非常に簡単でした。すべてのデバイスに対応しているため、友人や家族とイベントの詳細をシームレスに共有できるようになりました。",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & 創業者",
        content:
          "QR Doveのカスタマーサポートは素晴らしいです！このQRコードプラットフォームは、すべての問題を迅速に解決することを保証する、親切で知識豊富なサービスを提供しています。QR Doveを強くお勧めし、今後も長年にわたって使用するのが楽しみです。",
      },
      {
        name: "Vincent Vu",
        job: "開発者",
        content:
          "Web開発者として数多くのツールをテストしてきましたが、QR Doveは最高のQRコードプラットフォームとして際立っています。高度な機能とユーザーフレンドリーなインターフェースにより、業界で比類のない存在となっています。",
      },
      {
        name: "Libby Mcdonald",
        job: "デザイナー",
        content:
          "QR Doveは、非常に効率的で、驚くほど使いやすいQRコードプラットフォームです。Webサイトには、詳細なガイドと質問への即時回答が用意されており、QRコード作成に最適な選択肢となっています。絶賛のレビューはまさしくその通りでした！",
      },
      {
        name: "Esmee Allen",
        job: "セールスマネージャー",
        content:
          "私たちのチームは6か月以上QR Doveを使用していますが、気に入っています！このQRコードプラットフォームは、QRコードの作成、デザイン、展開を簡素化し、優れたカスタマーサポートがスムーズな体験を保証します。",
      },
      {
        name: "Kacper Bennett",
        job: "マーケター",
        content:
          "QR Doveは究極のQRコードプラットフォームです！4か月間使用していますが、どれだけお勧めしても足りません。信頼性が高く、効率的で、すべてのマーケティングニーズに最適です。",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        name: "Alaya Walsh",
        job: "作家",
        content:
          "使用QR Dove（领先的二维码平台）来制作婚礼邀请函二维码非常轻松。由于它与所有设备兼容，因此可以轻松与朋友和家人分享活动详细信息。",
      },
      {
        name: "Lawrence Holland",
        job: "首席执行官兼创始人",
        content:
          "QR Dove的客户支持非常出色！这个二维码平台提供友好且知识渊博的服务，确保所有问题都能及时解决。我强烈推荐QR Dove，并期待在未来几年继续使用它。",
      },
      {
        name: "Vincent Vu",
        job: "开发人员",
        content:
          "作为一名Web开发人员，我测试过许多工具，但QR Dove脱颖而出，成为最佳的二维码平台。其先进的功能和用户友好的界面使其在行业中无与伦比。",
      },
      {
        name: "Libby Mcdonald",
        job: "设计师",
        content:
          "QR Dove是一个高效且非常易于使用的二维码平台。该网站提供详细的指南和问题的即时解答，使其成为创建二维码的首选。好评如潮，名不虚传！",
      },
      {
        name: "Esmee Allen",
        job: "销售经理",
        content:
          "我们的团队已经使用QR Dove超过六个月了，而且非常喜欢！这个二维码平台简化了二维码的创建、设计和部署，他们出色的客户支持确保了流畅的体验。",
      },
      {
        name: "Kacper Bennett",
        job: "营销人员",
        content:
          "QR Dove是终极的二维码平台！我已经使用了四个月，并且强烈推荐。它可靠、高效，并且非常适合所有营销需求。",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        name: "Alaya Walsh",
        job: "Nhà văn",
        content:
          "Sử dụng mã QR cho thiệp mời đám cưới trở nên dễ dàng với QR Dove, nền tảng Mã QR hàng đầu. Việc chia sẻ thông tin chi tiết về sự kiện với bạn bè và gia đình trở nên liền mạch nhờ khả năng tương thích trên tất cả các thiết bị.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & người sáng lập",
        content:
          "Hỗ trợ khách hàng của QR Dove thật tuyệt vời! Nền tảng Mã QR này cung cấp dịch vụ thân thiện, am hiểu, đảm bảo mọi vấn đề đều được giải quyết kịp thời. Tôi rất khuyến khích QR Dove và mong muốn được sử dụng nó trong nhiều năm tới.",
      },
      {
        name: "Vincent Vu",
        job: "Nhà phát triển",
        content:
          "Là một nhà phát triển web, tôi đã thử nghiệm nhiều công cụ, nhưng QR Dove nổi bật là nền tảng Mã QR tốt nhất. Các tính năng nâng cao và giao diện thân thiện với người dùng của nó khiến nó trở nên vô song trong ngành.",
      },
      {
        name: "Libby Mcdonald",
        job: "Nhà thiết kế",
        content:
          "QR Dove là một nền tảng Mã QR rất hiệu quả và cực kỳ dễ sử dụng. Trang web cung cấp các hướng dẫn chi tiết và câu trả lời tức thì cho các câu hỏi, khiến nó trở thành lựa chọn hàng đầu để tạo mã QR. Những đánh giá tích cực là hoàn toàn chính xác!",
      },
      {
        name: "Esmee Allen",
        job: "Quản lý bán hàng",
        content:
          "Đội ngũ của chúng tôi đã sử dụng QR Dove trong hơn sáu tháng và rất thích nó! Nền tảng Mã QR này đơn giản hóa việc tạo, thiết kế và triển khai mã QR, đồng thời hỗ trợ khách hàng xuất sắc của họ đảm bảo trải nghiệm mượt mà.",
      },
      {
        name: "Kacper Bennett",
        job: "Nhà tiếp thị",
        content:
          "QR Dove là nền tảng Mã QR tối ưu! Tôi đã sử dụng nó trong bốn tháng và không thể giới thiệu nó đủ. Nó đáng tin cậy, hiệu quả và hoàn hảo cho mọi nhu cầu tiếp thị.",
      },
    ],
  },
  {
    locale: "id",
    data: [
      {
        name: "Alaya Walsh",
        job: "Penulis",
        content:
          "Menggunakan kode QR untuk undangan pernikahan sangat mudah dengan QR Dove, platform Kode QR terkemuka. Berbagi detail acara dengan teman dan keluarga menjadi lancar, berkat kompatibilitasnya di semua perangkat.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & Pendiri",
        content:
          "Dukungan pelanggan QR Dove sangat luar biasa! Platform Kode QR ini menyediakan layanan yang ramah dan berpengetahuan yang memastikan semua masalah diselesaikan dengan segera. Saya sangat merekomendasikan QR Dove dan berharap untuk menggunakannya selama bertahun-tahun yang akan datang.",
      },
      {
        name: "Vincent Vu",
        job: "Pengembang",
        content:
          "Sebagai pengembang web, saya telah menguji banyak alat, tetapi QR Dove menonjol sebagai platform Kode QR terbaik. Kemampuan canggih dan antarmuka yang ramah pengguna menjadikannya tak tertandingi di industri.",
      },
      {
        name: "Libby Mcdonald",
        job: "Desainer",
        content:
          "QR Dove adalah platform Kode QR yang sangat efisien yang sangat mudah digunakan. Situs web ini menawarkan panduan terperinci dan jawaban instan untuk pertanyaan, menjadikannya pilihan utama untuk pembuatan kode QR. Ulasan positifnya tepat sekali!",
      },
      {
        name: "Esmee Allen",
        job: "Manajer Penjualan",
        content:
          "Tim kami telah menggunakan QR Dove selama lebih dari enam bulan dan menyukainya! Platform Kode QR ini menyederhanakan pembuatan, desain, dan penerapan kode QR, dan dukungan pelanggan mereka yang luar biasa memastikan pengalaman yang lancar.",
      },
      {
        name: "Kacper Bennett",
        job: "Pemasar",
        content:
          "QR Dove adalah platform Kode QR terbaik! Saya telah menggunakannya selama empat bulan dan sangat merekomendasikannya. Ini andal, efisien, dan sempurna untuk semua kebutuhan pemasaran.",
      },
    ],
  },
  {
    locale: "tr",
    data: [
      {
        name: "Alaya Walsh",
        job: "Yazar",
        content:
          "Düğün davetiyeleri için QR kodları kullanmak, lider QR Kod platformu olan QR Dove ile çok kolaydı. Tüm cihazlarda uyumluluğu sayesinde etkinlik ayrıntılarını arkadaşlarınız ve ailenizle paylaşmak sorunsuz hale geldi.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & Kurucu",
        content:
          "QR Dove'un müşteri desteği olağanüstü! Bu QR Kod platformu, tüm sorunların hızlı bir şekilde çözülmesini sağlayan samimi, bilgili bir hizmet sunmaktadır. QR Dove'u şiddetle tavsiye ediyorum ve uzun yıllar boyunca kullanmayı dört gözle bekliyorum.",
      },
      {
        name: "Vincent Vu",
        job: "Geliştirici",
        content:
          "Bir web geliştiricisi olarak sayısız araç test ettim, ancak QR Dove en iyi QR Kod platformu olarak öne çıkıyor. Gelişmiş yetenekleri ve kullanıcı dostu arayüzü, onu sektörde rakipsiz kılıyor.",
      },
      {
        name: "Libby Mcdonald",
        job: "Tasarımcı",
        content:
          "QR Dove, kullanımı inanılmaz kolay olan, yüksek verimli bir QR Kod platformudur. Web sitesi, ayrıntılı kılavuzlar ve sorulara anında yanıtlar sunarak QR kod oluşturma için en iyi seçenek haline geliyor. Olumlu yorumlar tamamen doğruydu!",
      },
      {
        name: "Esmee Allen",
        job: "Satış Müdürü",
        content:
          "Ekibimiz QR Dove'u altı aydan uzun süredir kullanıyor ve çok seviyor! Bu QR Kod platformu, QR kodlarının oluşturulmasını, tasarlanmasını ve dağıtımını basitleştiriyor ve olağanüstü müşteri destekleri sorunsuz bir deneyim sağlıyor.",
      },
      {
        name: "Kacper Bennett",
        job: "Pazarlamacı",
        content:
          "QR Dove, en iyi QR Kod platformudur! Dört aydır kullanıyorum ve ne kadar tavsiye etsem azdır. Güvenilir, verimli ve tüm pazarlama ihtiyaçları için mükemmel.",
      },
    ],
  },
  {
    locale: "hi",
    data: [
      {
        name: "अलाया वॉल्श",
        job: "लेखक",
        content:
          "क्यूआर डव, प्रमुख क्यूआर कोड प्लेटफ़ॉर्म के साथ शादी के निमंत्रणों के लिए क्यूआर कोड का उपयोग करना बहुत आसान था। सभी उपकरणों में इसकी संगतता के कारण दोस्तों और परिवार के साथ कार्यक्रम विवरण साझा करना आसान हो गया।",
      },
      {
        name: "लॉरेंस हॉलैंड",
        job: "सीईओ और संस्थापक",
        content:
          "क्यूआर डव की ग्राहक सहायता असाधारण है! यह क्यूआर कोड प्लेटफ़ॉर्म मैत्रीपूर्ण, जानकार सेवा प्रदान करता है जो यह सुनिश्चित करता है कि सभी मुद्दों का तुरंत समाधान हो जाए। मैं क्यूआर डव की अत्यधिक अनुशंसा करता हूं और आने वाले वर्षों में इसका उपयोग करने के लिए उत्सुक हूं।",
      },
      {
        name: "विन्सेंट वू",
        job: "डेवलपर",
        content:
          "एक वेब डेवलपर के रूप में, मैंने कई उपकरणों का परीक्षण किया है, लेकिन क्यूआर डव सबसे अच्छे क्यूआर कोड प्लेटफ़ॉर्म के रूप में सामने आया है। इसकी उन्नत क्षमताएं और उपयोगकर्ता के अनुकूल इंटरफ़ेस इसे उद्योग में बेजोड़ बनाते हैं।",
      },
      {
        name: "लिबी मैकडोनाल्ड",
        job: "डिजाइनर",
        content:
          "क्यूआर डव एक अत्यधिक कुशल क्यूआर कोड प्लेटफ़ॉर्म है जिसका उपयोग करना अविश्वसनीय रूप से आसान है। वेबसाइट विस्तृत मार्गदर्शिकाएँ और प्रश्नों के त्वरित उत्तर प्रदान करती है, जिससे यह क्यूआर कोड निर्माण के लिए एक पसंदीदा विकल्प बन जाती है। शानदार समीक्षाएँ बिल्कुल सही थीं!",
      },
      {
        name: "एस्मी एलन",
        job: "सेल्स मैनेजर",
        content:
          "हमारी टीम छह महीने से अधिक समय से क्यूआर डव का उपयोग कर रही है और इसे पसंद करती है! यह क्यूआर कोड प्लेटफ़ॉर्म क्यूआर कोड के निर्माण, डिज़ाइन और परिनियोजन को सरल करता है, और उनका उत्कृष्ट ग्राहक समर्थन एक सहज अनुभव सुनिश्चित करता है।",
      },
      {
        name: "कैस्पर बेनेट",
        job: "मार्केटर",
        content:
          "क्यूआर डव अंतिम क्यूआर कोड प्लेटफ़ॉर्म है! मैं इसे चार महीने से उपयोग कर रहा हूं और इसे जितना भी कहूं कम ही है। यह विश्वसनीय, कुशल और सभी मार्केटिंग आवश्यकताओं के लिए एकदम सही है।",
      },
    ],
  },
  {
    locale: "th",
    data: [
      {
        name: "Alaya Walsh",
        job: "นักเขียน",
        content:
          "การใช้รหัส QR สำหรับคำเชิญงานแต่งงานเป็นเรื่องง่ายด้วย QR Dove ซึ่งเป็นแพลตฟอร์มรหัส QR ชั้นนำ การแบ่งปันรายละเอียดกิจกรรมกับเพื่อนและครอบครัวเป็นไปอย่างราบรื่นด้วยความเข้ากันได้ในทุกอุปกรณ์",
      },
      {
        name: "Lawrence Holland",
        job: "CEO และผู้ก่อตั้ง",
        content:
          "ฝ่ายสนับสนุนลูกค้าของ QR Dove นั้นยอดเยี่ยมมาก! แพลตฟอร์มรหัส QR นี้ให้บริการที่เป็นมิตรและมีความรู้ซึ่งทำให้มั่นใจได้ว่าปัญหาทั้งหมดจะได้รับการแก้ไขอย่างรวดเร็ว ฉันขอแนะนำ QR Dove อย่างยิ่งและหวังว่าจะได้ใช้งานต่อไปอีกหลายปี",
      },
      {
        name: "Vincent Vu",
        job: "นักพัฒนา",
        content:
          "ในฐานะนักพัฒนาเว็บ ฉันได้ทดสอบเครื่องมือมากมาย แต่ QR Dove โดดเด่นในฐานะแพลตฟอร์มรหัส QR ที่ดีที่สุด ความสามารถขั้นสูงและอินเทอร์เฟซที่เป็นมิตรต่อผู้ใช้ทำให้ไม่เป็นสองรองใครในอุตสาหกรรม",
      },
      {
        name: "Libby Mcdonald",
        job: "นักออกแบบ",
        content:
          "QR Dove เป็นแพลตฟอร์มรหัส QR ที่มีประสิทธิภาพสูงและใช้งานง่ายอย่างไม่น่าเชื่อ เว็บไซต์มีคำแนะนำโดยละเอียดและคำตอบสำหรับคำถามทันที ทำให้เป็นตัวเลือกอันดับหนึ่งสำหรับการสร้างรหัส QR บทวิจารณ์ที่ยอดเยี่ยมนั้นถูกต้อง!",
      },
      {
        name: "Esmee Allen",
        job: "ผู้จัดการฝ่ายขาย",
        content:
          "ทีมงานของเราใช้ QR Dove มานานกว่าหกเดือนแล้วและชอบมันมาก! แพลตฟอร์มรหัส QR นี้ทำให้การสร้าง ออกแบบ และปรับใช้รหัส QR เป็นเรื่องง่าย และการสนับสนุนลูกค้าที่โดดเด่นทำให้มั่นใจได้ถึงประสบการณ์ที่ราบรื่น",
      },
      {
        name: "Kacper Bennett",
        job: "นักการตลาด",
        content:
          "QR Dove เป็นแพลตฟอร์มรหัส QR ที่ดีที่สุด! ฉันใช้มาสี่เดือนแล้วและไม่สามารถแนะนำได้มากพอ มีความน่าเชื่อถือ มีประสิทธิภาพ และสมบูรณ์แบบสำหรับทุกความต้องการด้านการตลาด",
      },
    ],
  },
];
